import { ProductsCompany } from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type {CompanyProductPickState} from "../companyProductPickState";

export class PickProduct extends Action<"PICK_PRODUCT", ProductsCompany | undefined> {
  readonly type = "PICK_PRODUCT";
  protected state: CompanyProductPickState;

  constructor(state: CompanyProductPickState, data?: ProductsCompany | undefined) {
    super(state, data);
    this.state = state;
  }

  isDoable(): boolean {
    const {basisType} = this.state.bookingflowStateMachine.getData();
    const isRequiredValuesSet = this.allHasValues([basisType]);
    return isRequiredValuesSet;
  }

  isValid(): boolean {
    const productType = this?.data;
    const isCompanyProduct = (productType && (productType === "Booking" || productType === "CompanyLead")) || false;
    return isCompanyProduct && this.isDoable();
  }
}
